<template>
  <v-dialog v-model="dialog" content-class="v-dialog--custom"
    :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-card-title class="headline">Instant Payment History</v-card-title>
      <v-card-text>
        <v-skeleton-loader
          v-if="loading"
          class="mx-auto"
          type="table"
        ></v-skeleton-loader>
        <v-data-table
          v-else
          :headers="headers"
          :items="items"
          :options.sync="tableOptions"
          :server-items-length="totalItems"
          class="elevation-1"
          :loading="loading"
        >
          <template v-slot:item.date="{ item }">
            {{ item.date | formatDatetime }}
          </template>

          <template v-slot:item.amount="{ item }">
            {{ item.amount | formatPrice }}
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeDelete">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import formatterMixin from "@/mixins/formatterMixin";
import _ from "lodash";

export default {
  mixins: [formatterMixin],
  props: {
    item: [Object, String],
    show: [Boolean, String],
  },
  data() {
    return {
      dialog: false,
      namespace: "Invoices",
      page: "Invoices",
      filter: {
        SearchTerm: null,
        method: null,
        status: null,
        dateStart: null,
        dateEnd: null,
      },

      tableOptions: {},

      clients: [],

      headers: [
        {
          text: "Paid At",
          sortable: true,
          value: "date",
        },
        {
          text: "Status",
          sortable: true,
          value: "status",
        },
        {
          text: "Total Amount",
          sortable: true,
          value: "amount",
        },
        {
          text: "Method",
          sortable: true,
          value: "method",
        },
        {
          text: "Notes",
          sortable: true,
          value: "notes",
        },
      ],
    };
  },

  computed: {
    ...mapState({
      subscription: (state) => state.subscription,
      items: (state) => state.subscription.data,
      loading: (state) => state.subscription.loadingTable,
      totalItems: (state) => state.subscription.metaData.totalEntries
    }),

    computedFilter() {
      const { method, dateStart, dateEnd, status, SearchTerm } = this.filter;
      let { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions;
      let params = {
        PageNumber: page ? page : 1,
        PageSize: itemsPerPage > 0 ? itemsPerPage : 10,
      };
      params.OrderBy =
        sortBy && sortBy.length > 0 && sortBy[0] ? sortBy[0] : "dateCreated";
      params.Ascending =
        sortDesc && typeof sortDesc[0] !== "undefined" ? sortDesc[0] : false;

      if (status) {
        params.status = status;
      }

      if (method) {
        params.method = method;
      }

      if (dateStart) {
        params.dateStart = dateStart;
      }

      if (dateEnd) {
        params.dateEnd = dateEnd;
      }

      if (SearchTerm) {
        params.SearchTerm = SearchTerm;
      }
      return params;
    },
  },
  watch: {
    async dialog(n) {
      if (n) {
        await this.refresh();
      } else {
        this.$emit("onClosed");
      }
    },
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },
    tableOptions: {
      async handler(n, o) {
        if (JSON.stringify(n) !== JSON.stringify(o)) {
          await this.refresh();
        }
      },
      deep: true,
    },

    filter: {
      async handler() {
        await this.refresh();
      },
      deep: true,
    },
  },

  async mounted() {
    await this.refresh();
  },

  methods: {
    ...mapActions("subscription", ["applyTableFilter", "clearTableFilter"]),

    ...mapActions("category", ["delete"]),

    closeDelete() {
      this.dialog = false;
      this.$emit("onClosed");
    },
    refresh: _.debounce(async function () {
      this.applyTableFilter(this.computedFilter);
    }, 500),
  },

  beforeDestroy() {
    this.clearTableFilter();
  },
};
</script>